import {Permissions} from "@/js/Permissions";

const DisputeRoutes = [
  {
    path: "/disputes",
    name: "disputes_index",
    component: () => import("@/views/disputes/IndexView.vue"),
    meta: {permissions: [Permissions.DISPUTES]},
  },
  {
    path: "/disputes/create",
    name: "disputes_create",
    component: () => import("@/views/disputes/CreateView.vue"),
    meta: {permissions: [Permissions.DISPUTES]},
  },
  {
    path: "/disputes/catch-all-inbox",
    name: "catch_all_inbox",
    component: () => import("@/views/disputes/CatchAllInboxView.vue"),
    meta: {permissions: [Permissions.DISPUTES]},
  },
  {
    path: "/disputes/:id",
    name: "disputes_edit",
    component: () => import("@/views/disputes/EditView.vue"),
    meta: {permissions: [Permissions.DISPUTES, Permissions.PREVIEW_DISPUTE]},
  },
]

export default DisputeRoutes;
